import { useSelector } from 'react-redux';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import { getSelectedForecastTypeProperties } from '../../selectors/forecastSelectors';
import { getIsUngatedToForecastingMultipleOutcomes } from '../../selectors/authSelectors';
import { ForecastingDealSplitIcon } from '../ForecastingDealSplitIcon';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectedDealAmountTotal = ({
  dealsWithDealSplitsSelected,
  // TODO: Remove this prop when cleaning up Forecasting:MultipleOutcomes gate
  totalLoading,
  totalToDisplay
}) => {
  var _useSelector;
  const isUngatedToFMO = useSelector(getIsUngatedToForecastingMultipleOutcomes);
  const amountProperty = (_useSelector = useSelector(getSelectedForecastTypeProperties)) === null || _useSelector === void 0 ? void 0 : _useSelector.amountProperty;
  if (!totalToDisplay || !(typeof totalToDisplay.value === 'number')) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    marginInlineEnd: "200",
    as: "div",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "start",
      flexDirection: "row",
      flexWrap: "wrap",
      children: [isUngatedToFMO && amountProperty ? amountProperty : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealTableOverviewHeader.selectedDealAmount"
      }), totalLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
        marginInlineStart: "200",
        size: "extra-small"
      }) : /*#__PURE__*/_jsx(Text, {
        typography: "heading-100",
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
          value: totalToDisplay.value,
          currencyCode: totalToDisplay.currencyCode
        })
      }), dealsWithDealSplitsSelected && /*#__PURE__*/_jsx(ForecastingDealSplitIcon, {})]
    })
  });
};
export default SelectedDealAmountTotal;